import { evaluateDemoGate } from '@the-hive-frontend/libs/demo/magic-link';

import { environment } from '../../../environments/environment';

function renderNeutralPage(): void {
  document.title = 'Not found';
  document.body.innerHTML = `
    <div style="
      display:flex;align-items:center;justify-content:center;
      min-height:100vh;margin:0;
      font:16px/1.5 system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;
      color:#4a5568;background:#fff;">
      <p>Nothing to see here.</p>
    </div>`;
}

export async function passesDemoGate(): Promise<boolean> {
  const expectedHash = environment.demo.magicLinkHash;
  if (!expectedHash) {
    return true;
  }

  const { granted } = await evaluateDemoGate(expectedHash);
  if (!granted) {
    renderNeutralPage();
  }
  return granted;
}
